import React from "react";
import { useNavigate } from "react-router-dom";
import { Star, Clock, MapPin, ArrowRight } from "lucide-react";

export default function StoreCard({ store }) {
  const nav = useNavigate();
  const grace = store.subscription?.status === "grace";
  return (
    <div
      data-testid="store-card-item"
      onClick={() => nav(`/stores/${store.id}`)}
      className="group cursor-pointer overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-[0_2px_12px_rgba(0,0,0,0.04)] transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_12px_32px_rgba(5,150,105,0.12)]"
    >
      <div className="relative h-32 overflow-hidden">
        <img src={store.cover} alt={store.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
        {store.is_featured && (
          <span className="absolute left-3 top-3 rounded-full bg-amber-surge px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">Featured</span>
        )}
        <img src={store.logo} alt="" className="absolute -bottom-5 left-4 h-12 w-12 rounded-xl border-2 border-white object-cover shadow-md" />
      </div>
      <div className="p-4 pt-6">
        <h3 className="line-clamp-1 font-head text-base font-bold text-slate-900">{store.name}</h3>
        <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
          <span data-testid="store-rating-badge" className="inline-flex items-center gap-1 rounded-md bg-brand px-1.5 py-0.5 font-bold text-white">
            <Star className="h-3 w-3 fill-white" />{store.rating}
          </span>
          <span data-testid="store-eta-badge" className="inline-flex items-center gap-1 rounded-md bg-amber-soft px-1.5 py-0.5 font-bold text-amber-warm">
            <Clock className="h-3 w-3" />{store.delivery_time_min}-{store.delivery_time_max} min
          </span>
          {store.distance_km != null && store.distance_km <= 50 && (
            <span data-testid="store-distance-badge" className="inline-flex items-center gap-1 text-slate-500">
              <MapPin className="h-3 w-3" />{store.distance_km} km
            </span>
          )}
        </div>
        {grace && <p className="mt-2 text-[11px] font-medium text-amber-warm">Renewing soon</p>}
        <div data-testid="store-shop-btn" className="mt-3 flex items-center justify-center gap-1.5 rounded-xl border border-brand/30 bg-brand-soft py-2 text-xs font-bold text-brand transition-colors group-hover:bg-brand group-hover:text-white">
          Shop store <ArrowRight className="h-3.5 w-3.5" />
        </div>
      </div>
    </div>
  );
}
